var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.031,
    height: 618.112,
    viewBox: "0 0 799.031 618.112",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,488.763c0,.872.478,1.573,1.073,1.573h535.1c.6,0,1.073-.7,1.073-1.573s-.478-1.573-1.073-1.573H16.253C15.658,487.191,15.18,487.891,15.18,488.763Z",
    transform: "translate(674.711 358.776)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(865.162 842.354)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.105,
    height: 3.371,
    transform: "translate(1034.295 842.917)",
    fill: "#b6b3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.955,370.945a27.529,27.529,0,0,1-54.321,0H229.146V521.536h193.3V370.945Z",
    transform: "translate(633.721 321.378)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 193.296,
    height: 5.242,
    transform: "translate(863.43 830.983)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.255,487.17H10.776A10.788,10.788,0,0,1,0,476.394V32.688A10.788,10.788,0,0,1,10.776,21.911H788.255a10.789,10.789,0,0,1,10.776,10.776V476.394a10.789,10.789,0,0,1-10.776,10.776Z",
    transform: "translate(560 209.089)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 760.822,
    height: 429.297,
    transform: "translate(578.104 247.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(451 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0H248a8,8,0,0,1,8,8V120a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(607 531)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(623 539)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(633 539)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(643 539)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H90a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(639 571)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0h4a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(621 571)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H74a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(621 591)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H114a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(703 591)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0h4a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(621 611)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H118a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(639 611)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H412a8,8,0,0,1,8,8V352a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(603 284)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(619 292)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(629 292)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z",
    transform: "translate(639 292)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 329)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 353)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 377)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 401)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 425)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 584)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(619 608)",
    fill: "#39374d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,0,8H4A4,4,0,0,1,4,0Z",
    transform: "translate(655 329)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,0,8H4A4,4,0,0,1,4,0Z",
    transform: "translate(655 345.306)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,0,8H4A4,4,0,0,1,4,0Z",
    transform: "translate(655 361.613)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,0,8H4A4,4,0,0,1,4,0Z",
    transform: "translate(655 377.919)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H60a4,4,0,0,1,0,8H4A4,4,0,0,1,4,0Z",
    transform: "translate(655 394.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H90a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(751 329)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H154a6,6,0,0,1,0,12H6A6,6,0,0,1,6,0Z",
    transform: "translate(760 369)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0h105c4.142,0,7.5,2.686,7.5,6s-3.358,6-7.5,6H7.5C3.358,12,0,9.314,0,6S3.358,0,7.5,0Z",
    transform: "translate(759.552 349)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0h105c4.142,0,7.5,2.686,7.5,6s-3.358,6-7.5,6H7.5C3.358,12,0,9.314,0,6S3.358,0,7.5,0Z",
    transform: "translate(760 389)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0h105c4.142,0,7.5,2.686,7.5,6s-3.358,6-7.5,6H7.5C3.358,12,0,9.314,0,6S3.358,0,7.5,0Z",
    transform: "translate(751 409)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0H244a12,12,0,0,1,12,12V148a12,12,0,0,1-12,12H12A12,12,0,0,1,0,148V12A12,12,0,0,1,12,0Z",
    transform: "translate(1058 284)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(887.403 -98.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(1016.863 -98.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(950.849 -98.859)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(887.403 -50.638)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(1016.863 -50.638)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(950.849 -50.638)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(887.403 -5.25)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(1016.863 -5.25)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.67,427.859H213.816a2.668,2.668,0,0,1-2.665-2.665V403.307a2.668,2.668,0,0,1,2.665-2.665H218.7a2.659,2.659,0,0,1,1.793.693l5.3,3.784a1.872,1.872,0,0,0,1.265.49h26.859a2.665,2.665,0,0,1,2.665,2.7l-.247,16.92A2.676,2.676,0,0,1,253.67,427.859Z",
    transform: "translate(950.849 -5.25)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.e7f7aa086dab7b7f04bc0c3ca0d47251.svg";
export { ForwardRef as ReactComponent };